'use client';
/**
 * /advertise 상품 단락의 «이 광고 바로 신청» — /ads/buy 로 상품을 미리 골라 보낸다.
 * /advertise 는 ISR(주소를 서버가 읽지 않음) → 서버 HTML 은 상품만 고른 주소, 브라우저에서 주소의 ?sg=(시군구)·?site=(현장)·?from= 을 이어 붙인다.
 * 모든 방문자 같은 HTML. ⛔ 금액 문구 없음.
 */
import { useEffect, useState } from 'react';
import { buyHref, isDistrictKey, isSiteId, type BuyProduct } from '@/lib/ads/buy-link';
import { trackAdvertiseClick } from './track';

export default function BuyCta({ product, label = '이 광고 바로 신청', from = 'advertise_page', style }: { product: BuyProduct; label?: string; from?: string; style?: React.CSSProperties }) {
  const [href, setHref] = useState(() => buyHref({ product, from }));
  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      const f = sp.get('from');
      const src = f && /^[a-z0-9_]{1,30}$/.test(f) ? f : from;
      const site = sp.get('site');
      const sg = sp.get('sg');
      setHref(buyHref({ product, from: src, site: isSiteId(site) ? site : null, district: isDistrictKey(sg) ? sg : null }));
    } catch { /* 주소 못 읽으면 상품만 고른 주소 그대로 */ }
  }, [product, from]);
  return (
    <a
      href={href}
      rel="nofollow"
      data-buy-cta={product}
      onClick={() => trackAdvertiseClick(`buy_${product}`)}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 48, marginTop: 14, borderRadius: 'var(--radius-sm, 8px)',
        background: 'var(--brand, #2563eb)', color: '#fff', fontWeight: 800, fontSize: 'var(--fs-md, 16px)', textDecoration: 'none',
        ...style,
      }}
    >
      {label} →
    </a>
  );
}
